import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=9d09d6fa&"
import script from "./Studio.vue?vue&type=script&lang=js&"
export * from "./Studio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports